import paymentsConfig from '@/config/payments.json'

const state = {
  checkoutId: null,
  loading: false,
  error: null,
  subscription: null,
}

const getters = {
  loading: state => state.loading,
  error: state => state.error,
  checkoutId: state => state.checkoutId,
  subscription: state => state.subscription,

  config: (state, getters, rootState, rootGetters) => {
    const org = rootGetters['client/organization/model']
    if (!org || !org.id) return null
    const orgConfig = paymentsConfig.clients[String(org.id)]
    if (!orgConfig) return null

    return {
      ...paymentsConfig.defaults,
      ...orgConfig,
    }
  },

  isWhitelisted: (state, getters) => {
    return paymentsConfig.enabled && !!getters.config
  },
}

const mutations = {
  setCheckoutId(state, checkoutId) {
    state.checkoutId = checkoutId
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  setError(state, error) {
    state.error = error
  },
  setSubscription(state, subscription) {
    state.subscription = subscription
  },
}

const actions = {
  async initiateCheckout({ commit }) {
    commit('setLoading', true)
    commit('setError', null)
    try {
      const { data } = await Vue.$http.post('client/payments/checkout')
      commit('setCheckoutId', data.checkoutId)
      return data
    } catch (e) {
      commit('setError', e.response ? e.response.data.error : 'Failed to initiate checkout')
      throw e
    } finally {
      commit('setLoading', false)
    }
  },

  async fetchSubscription({ commit }) {
    commit('setLoading', true)
    commit('setError', null)
    try {
      const { data } = await Vue.$http.get('client/payments/subscription')
      commit('setCheckoutId', null)
      commit('setSubscription', data)
      return data
    } catch (e) {
      // 404 means no subscription yet - that's fine
      if (e.response && e.response.status === 404) {
        commit('setCheckoutId', null)
        commit('setSubscription', null)
      } else {
        commit('setError', e.response ? e.response.data.error : 'Failed to fetch subscription')
      }
    } finally {
      commit('setLoading', false)
    }
  },

  async confirmPayment({ commit }, payload) {
    commit('setLoading', true)
    commit('setError', null)
    try {
      const { data } = await Vue.$http.post('client/payments/confirm', {
        checkoutId: payload.checkoutId,
      })
      commit('setCheckoutId', null)
      commit('setSubscription', data)
      return data
    } catch (e) {
      commit('setError', e.response ? e.response.data.error : 'Payment confirmation failed')
      throw e
    } finally {
      commit('setLoading', false)
    }
  },

  clearCheckout({ commit }) {
    commit('setCheckoutId', null)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
